import { render, staticRenderFns } from "./GsaSelection.vue?vue&type=template&id=42aba280&scoped=true"
import script from "./GsaSelection.vue?vue&type=script&lang=js"
export * from "./GsaSelection.vue?vue&type=script&lang=js"
import style0 from "./GsaSelection.vue?vue&type=style&index=0&id=42aba280&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42aba280",
  null
  
)

export default component.exports